import type { CSSProperties } from 'react'

/** Background image for the whitepaper marketing hero (landing + lead modal). */
export const WHITEPAPER_HERO_BG_SRC = '/assets/whitepapers/hero-bg.jpg'

/** Gradient overlay on the hero photo (same as `WhitepaperLandingPage`). */
export const whitepaperHeroOverlayStyle: CSSProperties = {
  backgroundImage: 'linear-gradient(243deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)',
}
